import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabDates from '../../form-fields/tab-dates/tab-dates';
class EditViewClientTabDates extends Component {
  render() {
    return (
      <div>
         <FormFieldsTabDates 
          {...this.props} 
          locked={this.props.locked} 
          referraloutcome={this.props.referraloutcome} 
          clientdischargestatus={this.props.clientdischargestatus} 
        />
      </div>
    );
  }
}
EditViewClientTabDates.propTypes = {
  locked: PropTypes.bool,
}
EditViewClientTabDates = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabDates);
export default EditViewClientTabDates;